import React from "react";
import Herosection from "../components/landingpage/Herosection";
// import Services from "../components/landingpage/Services";
import Servicesnew from "../components/landingpage/Servicesnew";
import Publishingsolution from "../components/landingpage/Publishingsolution";
// import Ourapproach from "../components/landingpage/Ourapproach";
import ClientCarousel from "../components/landingpage/ClientCarousel";
// import Highlights from "../components/landingpage/Highlights";
import data from "../json/landingpage/Clientcarousel.json";
// import OurExpertService from "../components/landingpage/OurExpertService";
import Highlightsnew from "../components/landingpage/Highlightsnew";
import { BusinessTarget } from "../components/landingpage/BusinessTarget";

const Landingpage = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">
      <Herosection />
      {/* <Services /> */}
      <Servicesnew />
      {/* <Ourapproach /> */}
      <Publishingsolution />
      {/* Businesstarget */}
      <BusinessTarget/>
      {/* <Highlights /> */}
      <Highlightsnew />
      <ClientCarousel data={data} />
    </div>
  );
};

export default Landingpage;
